import Login from '@/components/authentication/Login';

export const Route = createFileRoute({
	component: Login,
	validateSearch: (search: Record<string, unknown>): { email?: string; redirect?: string } => ({
		email: (search.email as string) || undefined,
		redirect: (search.redirect as string) || undefined,
	}),
});
